/* eslint-disable import/prefer-default-export */
/* eslint-disable camelcase */
import _, { cloneDeep } from 'lodash';
import { LinkedRecord } from '../shared/material_components/linked-cell';

interface PickerRecordSelection {
  newRecordSelection: {},
  oldRecordSelection: LinkedRecord[],
}

interface ItemSelected {
  recordId: string,
}

interface SelectableBuilder {
  pickerRecords: Record<string, any>[],
  currentlyLinkedRecords: any[],
}

interface SelectableItem {
  title: string,
  created_at: string,
  dueDate: string,
  selected: boolean,
}

export interface SelectableRecords {
  id?: SelectableItem,
}

export const buildSelectableRecords = ({
  pickerRecords,
  currentlyLinkedRecords,
}: SelectableBuilder): SelectableRecords => pickerRecords.reduce(
  (recordsObject, record: Record<string, any>) => {
    const { id } = record;
    const preSelectedRecord = !!currentlyLinkedRecords
      .find((rc: Record<string, any>) => rc.id === id);
    return {
      ...recordsObject,
      [id]: {
        selected: preSelectedRecord,
      },
    };
  }, {},
);

export const prepareSelectedRecords = ({
  newRecordSelection,
  oldRecordSelection,
}: PickerRecordSelection) => {
  const selection: ItemSelected[] = [];
  const filteredSelection = Object.keys(newRecordSelection);
  const linkedRecords = oldRecordSelection.map((rawRecord: LinkedRecord) => rawRecord.id);
  const filteredState = cloneDeep(newRecordSelection);
  _.intersection(filteredSelection, linkedRecords)
    .forEach((modifiedRecordId: string) => {
      const modifiedRecord = filteredState[modifiedRecordId]
      && filteredState[modifiedRecordId].selected;
      if (modifiedRecord) {
        selection.push({ recordId: modifiedRecordId });
      }
    });
  // oldAlreadyLinkedRecords
  linkedRecords
    .filter((rId: string) => !filteredSelection.includes(rId))
    .forEach((oldRecordId: string) => {
      selection.push({ recordId: oldRecordId });
    });
  // newSelectedRecords
  filteredSelection
    .filter((rId: string) => !linkedRecords.includes(rId))
    .forEach((newRecordId: string) => {
      const selectedRecord = filteredState[newRecordId]
      && filteredState[newRecordId].selected;
      if (selectedRecord) {
        selection.push({ recordId: newRecordId });
      }
    });
  return selection;
};
